/**
 * Der Helper beachtet die Unterschiede zwischen desktop und mobile
 */
class NavigationHelper {
    /**
     * Löst ein Navigationsereignis zur neuen URL aus
     * @param {string} url
     * @param {boolean} [prependLanguageIsocode] (true) Prefixe die URL mit dem language ISO code
     */
    goto(url) {
        window.location.assign(url);
    }

    /**
     * Lädt die aktuelle Seite neu
     */
    reload() {
        window.location.reload();
    }

    /**
     * Liefert aktuellen language ISO code
     */
     get language() {
        if (this._lang === void(0)) {
            // Prüfen, ob language-Prefix benötigt wird
            const html = document.querySelector('html');
            const active_lang = html.getAttribute('lang');
            const default_lang = html.getAttribute('data-default-lang');
            this._lang = (active_lang === default_lang) ? '' : active_lang;
        }
        return this._lang;
    }
}

export default new NavigationHelper();
